import { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * Pour empêcher qu'un champ contenant seulement des espaces soit accepté comme une valeur valide
 */

export function noWhitespaceValidator(control: AbstractControl): ValidationErrors | null {
  const isWhitespace = control.value && !control.value?.trim();
  return isWhitespace ? { whitespace: true } : null;
}